


































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { trainingMaterialDataModule } from '@/app/store/modules/trainingMaterial'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

@Component({
  name: 'TrainingMaterial',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  private selected = []
  public get isLoading() {
    return trainingMaterialDataModule.isLoading
  }
  public get page() {
    return trainingMaterialDataModule.Pages
  }
  public get limit() {
    return trainingMaterialDataModule.Limit
  }
  public created() {
    trainingMaterialDataModule.paginationParam.search = ''
    trainingMaterialDataModule.paginationParam.filter.category = Number(
      this.$route.params.id
    )
    this.getImage()
    this.getData()
  }
  public getData() {
    trainingMaterialDataModule.getTrainingMaterialData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    trainingMaterialDataModule.paginationParam.search = item
    this.getData()
  }

  // Property Table
  public get trainingCategoryData() {
    return trainingMaterialDataModule.trainingMaterialData
  }
  public fields: any = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'fileCode', sortable: false },
    { key: 'title', sortable: false },
    { key: 'fileName', sortable: false },
    { key: 'recommended', sortable: false },
    { key: 'image', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'expireddate', sortable: false },
    { key: 'actions', sortable: false },
  ]
  private onRowSelected(items) {
    this.selected = items
  }

  // Property Pagination
  private onPageNumChanged(limit: any) {
    trainingMaterialDataModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    trainingMaterialDataModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    trainingMaterialDataModule.paginationParam.paging.page =
      trainingMaterialDataModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    trainingMaterialDataModule.paginationParam.paging.page =
      trainingMaterialDataModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    trainingMaterialDataModule.paginationParam.paging.page =
      (this.trainingCategoryData.pagination &&
        this.trainingCategoryData.pagination.pageCount) ||
      0
    this.getData()
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
